import { Divider, Form, Select } from 'antd';
import PropTypes from 'prop-types';
import InputColor from '../../Shared/forms/InputColor';
import { CloseOutlined } from '@ant-design/icons';

const { Option } = Select;

export default function Customize({ handleClose }) {
    const mapTextFormat = [
        {
            label: 'ชื่อแบบฟอร์ม',
            name: 'formName',
        },
        {
            label: 'ชื่อส่วน',
            name: 'partName',
        },
        {
            label: 'คำถาม',
            name: 'question',
        },
        {
            label: 'คำอธิบาย',
            name: 'description',
        },
    ];

    return (
        <div className="sticky bg-white right-0 top-0 w-full h-full shadow-lg rounded-b-lg">
            <div className="flex items-center justify-between px-6 pt-6">
                <h2 className="font-semibold">ปรับแต่งธีม</h2>
                <button
                    className="text-2xl"
                    type="button"
                    onClick={handleClose}
                >
                    <CloseOutlined />
                </button>
            </div>
            <Divider />
            <div className="px-6">
                <div className="text-base text-purple-PHX font-semibold mb-4">
                    กำหนดสี
                </div>
                <Form.Item label="สีหลัก" name={['style', 'mainColor']}>
                    <InputColor />
                </Form.Item>
                <Form.Item
                    label="สีพื้นหลัง"
                    name={['style', 'backgroundColor']}
                >
                    <InputColor />
                </Form.Item>
            </div>
            <Divider />
            <div className="px-6 pb-6">
                <div className="text-base text-purple-PHX font-semibold mb-4">
                    กำหนดรูปแบบข้อความ
                </div>
                {mapTextFormat.map((item) => (
                    <div
                        key={item.name}
                        className="flex items-center gap-2 w-full"
                    >
                        <Form.Item
                            label={item.label}
                            name={[
                                'style',
                                'textFormat',
                                item.name,
                                'fontFamily',
                            ]}
                            className="w-full"
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: '100%' }}
                            >
                                <Option value="arial">Arial (EN)</Option>
                                <Option value="georgia">Georgia (EN)</Option>
                                <Option value="tahoma">Tahoma (EN)</Option>
                                <Option value="trebuchet">
                                    Trebuchet MS (EN)
                                </Option>
                                <Option value="verdana">Verdana (EN)</Option>
                                <Option value="prompt">Prompt (TH-EN)</Option>
                                <Option value="kanit">Kanit (TH-EN)</Option>
                                <Option value="sarabun">Sarabun (TH-EN)</Option>
                                <Option value="pridi">Pridit (TH-EN)</Option>
                                <Option value="noto_sans">
                                    Noto Sans Thai (TH-EN)
                                </Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="ขนาด"
                            name={[
                                'style',
                                'textFormat',
                                item.name,
                                'fontSize',
                            ]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                                <Option value="24px">24px</Option>
                                <Option value="28px">28px</Option>
                            </Select>
                        </Form.Item>
                    </div>
                ))}
            </div>
        </div>
    );
}

Customize.propTypes = {
    handleClose: PropTypes.func.isRequired,
};
